import React from "react";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import { Table } from "semantic-ui-react";
import { withTranslation } from "react-i18next";
import OtherProduct from "~/models/OtherProduct";
import CommonHelper from "~/utils/CommonHelper";
import UiMeet3dPackageInfos from "~/constants/UiMeet3d/UiMeet3dPackageInfos";

const SubscriptionItemTableRow = observer(
  ({ subscriptionItem, otherProduct, calculatePriceForDaysCallback, daysTillNextBillingCycle, t }) => (
    <Table.Row>
      <Table.Cell>
        {t(UiMeet3dPackageInfos[otherProduct.otherProductId].nameTranslationKey)}
        {daysTillNextBillingCycle !== 0 &&
          daysTillNextBillingCycle !== 30 &&
          ` (${daysTillNextBillingCycle} ${CommonHelper.firstLetterLower(t("days"))})`}
      </Table.Cell>
      <Table.Cell>{subscriptionItem.quantity}</Table.Cell>
      <Table.Cell>
        {CommonHelper.currencyFormat(
          calculatePriceForDaysCallback(parseFloat(otherProduct.price), daysTillNextBillingCycle),
        )}
      </Table.Cell>
      <Table.Cell textAlign="left">
        {CommonHelper.currencyFormat(
          subscriptionItem.quantity *
            calculatePriceForDaysCallback(parseFloat(otherProduct.price), daysTillNextBillingCycle),
        )}
      </Table.Cell>
    </Table.Row>
  ),
);

SubscriptionItemTableRow.propTypes = {
  t: PropTypes.func.isRequired,
  subscriptionItem: PropTypes.object.isRequired,
  otherProduct: PropTypes.instanceOf(OtherProduct),
  calculatePriceForDaysCallback: PropTypes.func.isRequired,
  daysTillNextBillingCycle: PropTypes.number,
};

SubscriptionItemTableRow.defaultProps = {
  daysTillNextBillingCycle: 0,
};

export default withTranslation()(SubscriptionItemTableRow);
